import { Component, OnInit } from '@angular/core';
import { CSVreportsService } from './csvreports.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-csvreports',
  templateUrl: './csvreports.component.html',
  styleUrls: ['./csvreports.component.css']
})
export class CsvreportsComponent implements OnInit {

  data = [];
  expanded: boolean[] = [];
  user: any;
  usernamee: string;
  canSeeIDtool = false;

  constructor(private service: CSVreportsService, private auth: AuthService) {}

  ngOnInit(): void {
    //load DR Horton Myrtle first
    this.service.getCSVReports(1327).subscribe((res: any) => {
      this.data = res.Data;
      this.expanded = new Array(this.data.length).fill(false);
    });

    this.auth.userProfile$.subscribe(
      (profile) => {
        var canSeeIDs = [185,151,130,371,56];
          canSeeIDs.
          indexOf(profile['https://rhv2.com.metadata'].id) > -1 ?  
          this.canSeeIDtool = true : this.canSeeIDtool = false;
        this.user = profile;
        this.usernamee = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
    });

  }

  toggleContent(index: number): void {
    this.expanded[index] = !this.expanded[index];
  }

  loadReports(id): void {
    this.service.getCSVReports(id).subscribe((res: any) => {
      this.data = res.Data;
      this.expanded = new Array(this.data.length).fill(false);
   });
  }

  openToolInNewTab(): void {
    window.open(this.service.getBaseURL() + '/id_tool', '_blank');
  }

}
